"use client";
import { useAuth } from "@/contexts/AuthContext";
import { useActivePartner } from "@/contexts/ActivePartnerContext";

export function useAnalyticsUserProps() {
    const { user } = useAuth();
    const { activePartnerCode, activeGrant } = useActivePartner();

    return () => ({
        partner_user_id: user?.userId ?? null,
        partner_code: activePartnerCode,
        partner_type: user?.internalRole ?? activeGrant?.partnerRole ?? null,
    });
}
